import { SupportedDatabaseType } from '../enum/database-drives.type';

export const supportedDatabases: SupportedDatabaseType[] = [
  'mssql',
  'postgres',
  'mysql',
  'mariadb',
  'cockroachdb',
  'sqlite',
  'better-sqlite3',
  'oracle',
  'mongodb',
  'sqljs',
  'cordova',
  'react-native',
  'expo',
  'nativescript',
];
